// Client-side admin session limit. The admin JWT auto-refreshes indefinitely,
// so this predicate is the only thing that eventually forces re-auth.
// Authentication is central (l2u-identity), so re-auth is usually a silent
// redirect rather than a login form — a 48-hour cap keeps that rare.
// NOTE: this is hygiene, not a security boundary. It lives in localStorage and
// is enforced in the browser; a server-enforced limit would be Supabase Auth's
// session timebox.
export const ABSOLUTE_MS = 48 * 60 * 60 * 1000; // 48 hours since sign-in

const SESSION_START_KEY = 'l2u-admin-session-start';

export function isAbsoluteExpired(
  sessionStartMs: number,
  nowMs: number,
  maxMs = ABSOLUTE_MS,
): boolean {
  return nowMs - sessionStartMs >= maxMs;
}

export function markSessionStart(nowMs: number): void {
  try {
    localStorage.setItem(SESSION_START_KEY, String(nowMs));
  } catch {
    /* private mode / storage disabled */
  }
}

// The stored anchor, seeding it to nowMs when a live session has none (e.g. a
// session predating this feature) so the absolute cap always has an anchor.
export function ensureSessionStart(nowMs: number): number {
  try {
    const parsed = Number(localStorage.getItem(SESSION_START_KEY));
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  } catch {
    /* ignore */
  }
  markSessionStart(nowMs);
  return nowMs;
}

export function clearSessionStart(): void {
  try {
    localStorage.removeItem(SESSION_START_KEY);
  } catch {
    /* ignore */
  }
}
